// global.$ = global.jQuery = require('jquery');

import { createApp } from 'vue'
import mitt from 'mitt'
import VueDataview from '../vue/views/Dataview.vue'

export class Dataview {

	constructor( elements ) {
        let _this = this        

        if ( elements.length ) {
            elements.forEach(function (item, key) {
            	const emitter = mitt()
				const app = createApp(VueDataview, {
					postId: item.getAttribute('data-post-id'),
					postSlug: item.getAttribute('data-post-slug'),
					isViewWrapper: item.getAttribute('data-is-viewwrapper')
				})
				app.config.globalProperties.emitter = emitter
				app.mount('#' + item.getAttribute('id') )    
            })
        }
	}
}